import withHelmet from 'src/hocs/withHelmet';
import { compose } from 'ramda';
import withProps from 'src/hocs/withProps';
import { t } from 'src/i18n';
import VerifyIdentityWrapper from './components/VerifyIdentityWrapper.component';

const enhance = compose(
  withProps({ title: t('general.title.verifyIdentity') }),
  withHelmet
);

export default enhance(VerifyIdentityWrapper);
